<svelte:head>
  <title>Terms of Service</title>
</svelte:head>

<script>
  import Layout from "$/client/Layout.svelte";
  import TOS from "$/client/components/TOS.svelte";
  import { onMount } from 'svelte';

  onMount(() => window.scrollTo(0, 0));
</script>


<Layout centered={ true }>
  <TOS />
</Layout>
